import useSWR from "swr";
import { api } from "@portal/arq-portal-core";

const key = "informesautos";
const service = "/be/informesautos/";
const config = { dedupingInterval: 60000 };

const useInformesAutos = (userid:string) =>  useSWR([key, userid], ()=>api.getAsync(service), config);

export default useInformesAutos;